module.exports = __webpack_public_path__ + "static/media/socanor.597394e9.png";